module.exports = __webpack_public_path__ + "media/src/web/images/home/heroimg_bg-40654be65b2763869ca64a9ec34a3fc7.webp";